import React, { useEffect } from "react";
import Input from "../../../form/Input";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import useMutation from "../../../../hooks/useMutation";
import { transactionAddEdit } from "../../../../services/transactionService";
import DatePicker from "../../../form/DatePicker";
import { toast } from "react-toastify";

const validation = {
  amount: { required: true, message: "amount is required" },
  date: { required: true, message: "recurring date is required" },
};
const RecurringDonation = ({ close = () => {}, details }) => {
  const {
    values,
    handleChange,
    handleSubmit,
    setFieldsValue,
    errors,
    formValidate,
  } = useForm({
    validationRules: validation,
  });
  useEffect(() => {
    if (details?._id) {
      setFieldsValue({
        ...details,
      });
    }
  }, [details]);
  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await transactionAddEdit({
        subscriptionId: details?.subscriptionId,
        amount: val?.amount || "",
        recurringDate: val?.date || "",
        categoryType: "donation",
        email: details?.email || "",
      });
    },
    onSuccess: (res) => {
      if (res?.status === 200) {
        toast.success(res?.message);
        close();
      } else {
        toast.error("Something Went Wrong!");
        close();
      }
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });
  console.log(details, "details");
  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-12 gap-x-4 gap-y-4">
        <div className="relative col-span-6">
          <Input
            label="Donor Firstname"
            inputPlaceholder={"Enter Donor Firstname"}
            inputName="firstName"
            value={values?.firstName}
            onChange={handleChange}
            isDisabled={true}
          />
        </div>
        <div className="relative col-span-6">
          <Input
            label="Donor Lastname"
            inputPlaceholder={"Enter Donor Lastname"}
            inputName="lastName"
            value={values?.lastName}
            onChange={handleChange}
            isDisabled={true}
          />
        </div>
        <div className="relative col-span-6">
          <Input
            label="Donor Email"
            inputPlaceholder={"Enter Donor Email"}
            inputName="email"
            value={values?.email}
            onChange={handleChange}
            isDisabled={true}
          />
        </div>
        <div className="relative col-span-6">
          <Input
            label="Donation Amount"
            inputPlaceholder={"Enter Donation Amount"}
            inputName="amount"
            // inputType={"number"}
            value={values?.amount}
            onChange={handleChange}
            {...formValidate(errors, "amount")}
          />
        </div>
        <div className="relative col-span-6">
          <DatePicker
            label={"Recurring Date"}
            placeholder={"Select Recurring Date"}
            value={{
              startDate: values?.date,
              endDate: values?.date,
            }}
            onChange={(e) => {
              handleChange({
                target: { value: e?.startDate, name: "date" },
              });
            }}
            {...formValidate(errors, "date")}
          />
        </div>
      </div>
      <div className="relative col-span-4 mt-5">
        <div className="flex items-center justify-center gap-4">
          <Button
            buttonType="submit"
            buttonLabel={"Save"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            {...(isLoading && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
          <Button
            buttonLabel={"Cancel"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            buttonFunction={close}
          />
        </div>
      </div>
    </form>
  );
};

export default RecurringDonation;
